import { render } from "./ValidateEmailView.vue?vue&type=template&id=b1724998"
import script from "./ValidateEmailView.vue?vue&type=script&lang=js"
export * from "./ValidateEmailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/auth/ValidateEmailView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1724998"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1724998', __exports__)) {
    api.reload('b1724998', __exports__)
  }
  
  module.hot.accept("./ValidateEmailView.vue?vue&type=template&id=b1724998", () => {
    api.rerender('b1724998', render)
  })

}


export default __exports__